import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from './zh'
import en from './en'
import ja from './ja'
import es from './es'
import ko from './ko'
import pt from './pt'
import trq from './trq'
import yn from './yn'
import yinni from './yinni'
import it from './it'
import fr from './fr'
import de from './de'
Vue.use(VueI18n); // 全局挂载

export const i18n = new VueI18n({
    locale: localStorage.getItem("locale") || "en", // 从localStorage中获取 默认英文
    messages: {
        zh,
        fr,
        en,
        de,
        ja,
        es,
        ko,
        pt,
        trq,
        yn,
        yinni,
        it
    }
});

export default i18n;